document.addEventListener('DOMContentLoaded', () => {
  // --- NAV MENU LOGIC ---
  const menuBtn = document.getElementById('hamburgerMenuBtn');
  const menuCloseBtn = document.getElementById('navMenuCloseBtn');
  const menuOverlay = document.getElementById('navMenuOverlay');

  if (menuBtn && menuOverlay && menuCloseBtn) {
    menuBtn.addEventListener('click', () => {
      menuOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    const closeMenu = () => {
      menuOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    menuCloseBtn.addEventListener('click', closeMenu);
    menuOverlay.addEventListener('click', (e) => {
      if (e.target === menuOverlay) closeMenu();
    });
  }

  // --- CART DRAWER LOGIC ---
  const cartToggle = document.getElementById('headerCartToggle');
  const cartCloseBtn = document.getElementById('cartDrawerCloseBtn');
  const cartOverlay = document.getElementById('cartDrawerOverlay');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartBody = document.getElementById('cartDrawerBody');
  const cartSubtotal = document.getElementById('cartDrawerSubtotal');
  const headerCartCount = document.getElementById('headerCartCount');

  const openCartDrawer = () => {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('is-active');
      cartOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
  };

  const closeCartDrawer = () => {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('is-active');
      cartOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  };

  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  const formatMoney = (cents) => {
    return (cents / 100).toFixed(2) + '€';
  };

  const fetchCart = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCart(cart);
      })
      .catch(err => console.error('Error fetching cart:', err));
  };

  const renderCart = (cart) => {
    if (headerCartCount) {
      headerCartCount.textContent = `(${cart.item_count})`;
    }
    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }
    
    if (!cartBody) return;

    if (cart.items.length === 0) {
      cartBody.innerHTML = '<div class="cart-drawer-empty">Your bag is empty.</div>';
      return;
    }

    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-drawer-item">
          <img src="${item.image}" alt="${item.title}" class="cart-drawer-item-img">
          <div class="cart-drawer-item-details">
            <div>
              <a href="${item.url}" class="cart-drawer-item-title">${item.product_title}</a>
              <div class="cart-drawer-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
              <div class="cart-drawer-item-price">${formatMoney(item.price)}</div>
            </div>
            <button class="cart-drawer-item-remove" data-key="${item.key}">REMOVE</button>
          </div>
        </div>
      `;
    });
    cartBody.innerHTML = html;

    // Attach remove listeners
    document.querySelectorAll('.cart-drawer-item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const key = e.target.getAttribute('data-key');
        updateCartItem(key, 0);
      });
    });
  };

  const updateCartItem = (key, qty) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(res => res.json())
    .then(cart => {
      renderCart(cart);
    })
    .catch(err => console.error('Error updating cart:', err));
  };

  // Intercept Add to Bag forms
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerText : 'ADDING...';
      if (submitBtn) {
        submitBtn.innerText = 'ADDING...';
        submitBtn.disabled = true;
      }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(item => {
        if (submitBtn) {
          submitBtn.innerText = originalText;
          submitBtn.disabled = false;
        }
        openCartDrawer();
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        if (submitBtn) {
          submitBtn.innerText = originalText;
          submitBtn.disabled = false;
        }
      });
    });
  });
});
